import { useContext, useMemo } from 'react';

import type { ConfigContextValue } from '@core/context';
import { ConfigContext, ProjectContext } from '@core/context';

/**
 * Determines if the app is in preview mode based on environment and user flags.
 * Returns true if both previewEnvironment and superHubPreviewFlag are true and dryRunPreviewFlag is false.
 */
const useIsPreviewMode = () => {
  const config = useContext(ConfigContext) as ConfigContextValue;
  const { project } = useContext(ProjectContext) || {};

  const previewEnvironment = config?.shMigration.migrationPreview;
  const superHubPreviewFlag = project.flags.superHubPreview;
  const dryRunPreviewFlag = project.flags.dryRunPreview;

  const isPreviewMode = useMemo(() => {
    return Boolean(previewEnvironment && superHubPreviewFlag) && !dryRunPreviewFlag;
  }, [previewEnvironment, superHubPreviewFlag, dryRunPreviewFlag]);

  return { isPreviewMode };
};

export default useIsPreviewMode;
